import React, { useRef, useEffect } from 'react';
import Header from 'modules/Shared/components/Header/Header';
import Footer from 'modules/Shared/components/Footer/Footer';
import Contact from 'modules/MainModule/components/Contact/Contact';
import StartNow from 'modules/Shared/components/StartNow/StartNow';
import { colorBackgroundBrightness } from 'data/common.data';
import '../ProductType.scss';
import { Helmet, HelmetProvider } from 'react-helmet-async';

const FlightWatcher = (props: any) => {
    useEffect(() => {
        window.scrollTo(0, 0);
    });
    const headerBg: string = '/images/backgrounds/ALEG-Image-Header-FlightWatcher_Header1.jpg'
    const styleData = { backgroundImage: `linear-gradient(${colorBackgroundBrightness}, ${colorBackgroundBrightness}), url(${headerBg})` };
    const contentData: string = 'Don\'t get stuck stuck at airport with AirLegit\'s smart analytic solutions';
    return (
        <>
            <HelmetProvider>
                <Helmet>
                    <title>Flight Watcher - Make Your Travelers Flight Insights</title>
                    <meta name='description' content={contentData} />
                </Helmet>
            </HelmetProvider>
            <Header />
            <div className='page-min-height product-type-data-container'>
                <div className='header-container container-side-padding container-content-padding' style={styleData}>
                    <div className='container-small-width'>
                        <div className='container no-padding'>
                            <div className='row'>
                                <div className='col-md-6 order-2 order-md-1'>
                                    <div className='product-logo-wrapper'>
                                        <img src='/images/icons/ALEG-ID-FlightWatcher.png' alt='Auto Check-in' />
                                    </div>
                                    <p className='no-margin'>
                                        We collect millions of data points and would like to have yours. We offer an Al- driven predictive analysis on flight performances and an array of ready- made applications to supplement your current customer experience.
                                    </p>
                                </div>
                                <div className='col-md-6 order-1 order-md-2'>
                                    <div className='logo-wrapper'>
                                        <img src='/images/others/ALEG-Image-Header_TabletPhone.png' alt='airlegit-devices' />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='colored-container container-side-padding container-content-padding'>
                    <div className='container-small-width'>
                        <div className='container no-padding'>
                            <div className='row'>
                                <div className='col-md-12 text-med'>
                                    AirLegit's FlightWatcher monitors flight status in real-time across five key data points: airline, airport, route, weather, and socio-political events pushing proactive insights and recommendations to your travelers.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='content-container container-side-padding container-content-padding'>
                    <div className='container-small-width'>
                        <div className='container no-padding'>
                            <div className='row'>
                                <div className='col-md-6 order-2 order-md-1'>
                                    <h3 className='text-med'>
                                        The 24x7 Traveler Command Center
                                    </h3>
                                    <p className='no-margin'>
                                        All AirLegit's partners have access to their dedicated Admin portal. While we monitor your traveler's itinerary, you benefit from a holistic view of all relevant travel variables. We keep travelers apprised with relevant insights and actionable recommendations sent by text, email or WhatsApp on your behalf. You have a holistic view and insightful reporting.
                                    </p>
                                </div>
                                <div className='col-md-6 order-1 order-md-2'>
                                    <div className='bordered-img-wrapper'>
                                        <img src='/images/others/ALEG-Image-Header_DashText.png' alt='frame' style={{ border: 'none' }} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <StartNow />
            </div>
            <Contact />
            <Footer />
        </>
    );
};

export default FlightWatcher;